import { IconCloudUpload, IconUpload } from "@tabler/icons-react";
import { AnyCnameRecord } from "dns";
import React, { useRef, useState, useEffect } from "react";

type Props = {
  name?: string;
  onFileSelect?: (file: File) => void;
  initialFile?: string | File;
  register?: any;
  validation?: any;
  error?: any;
  accept?: string;
};

const NewCustomFileInput = ({
  name,
  onFileSelect,
  initialFile,
  register,
  validation,
  error,
  accept = "image/*, application/pdf",
}: Props) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState("No file chosen");

  useEffect(() => {
    if (initialFile instanceof File) {
      setFileName(initialFile.name);
    } else if (typeof initialFile === "string") {
      const parts = initialFile.split("/").pop()?.split("?")[0];
      setFileName(parts || "No file chosen");
    } else {
      setFileName("No file chosen");
    }
  }, [initialFile]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
      onFileSelect?.(file);
    }
  };

  const [inputProps, setInputProps] = useState<any>({});

  useEffect(() => {
    if (name && register) {
      const registered = register(name, validation);
      setInputProps({
        ...registered,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          handleFileChange(e); // your custom file logic
          registered.onChange?.(e); // forward to RHF without recursion
        },
      });
    }
  }, [name, register]);

  return (
    <div className="w-full   space-y-1">
      <div
       
        className={`bg-[#ffffff] text-[#000] px-2 py-1 flex items-center gap-1 rounded-full border border-[#D8D8D8]  ${
          error ? "border-red-500" : "border-[#E0E0E0]"
        } rounded-full overflow-hidden`}
      >
        <div  onClick={() => fileRef.current?.click()} className="flex items-center justify-center py-[4px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20">
          <IconCloudUpload stroke={1.5} size={20} />
        </div>
        <div className="text-xs text-[#555] truncate">{fileName}</div>

        <input
          type="file"
          ref={(el) => {
            fileRef.current = el;
            if (inputProps?.ref) inputProps.ref(el);
          }}
          onChange={(e) => {
            handleFileChange(e);
            inputProps?.onChange?.(e); // important!
          }}
          name={inputProps?.name}
          className="hidden"
          accept={accept}
        />
      </div>
      {error?.message && (
        <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3 ">
          {error?.message || ""}
        </span>
      )}
    </div>
  );
};

export default NewCustomFileInput;
